import gql from 'graphql-tag';

export default gql`
query listFA_ProductGroup1 {
  fakturaAssist {
    listFA_ProductGroup1 {
      productGroup
    }
  }
}`;